export default {"src":"/_next/static/media/icon-profile-image-lg.72b792e0.svg","height":88,"width":88};